<template>
  <v-flex xs12>
    <v-text-field
      prepend-icon="attach_file"
      single-line
      v-model="filename"
      :label="label"
      :required="required"
      @click.native="onFocus"
      :disabled="disabled"
      ref="fileTextField"
      :error-messages="errors"
    />
    <input
      type="file"
      :accept="accept"
      :multiple="multiple"
      :disabled="disabled"
      ref="fileInput"
      @change="onFileChange"
    />
  </v-flex>
</template>

<script>
export default {
  props: {
    value: {
      type: [Array, String],
    },
    accept: {
      type: String,
      default: '*',
    },
    label: {
      type: String,
      default: 'choose_file',
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    callBack: Function,
  },
  data: () => ({
    filename: '',
    errors: [],
  }),
  watch: {
    value (v) {
      this.filename = v
    },
  },
  mounted () {
    this.filename = this.value
  },
  methods: {
    onFocus () {
      if (!this.disabled) {
        this.$refs.fileInput.click()
      }
    },
    onFileChange ($event) {
      const files = $event.target.files || $event.dataTransfer.files
      if (files) {
        if (files.length > 0) {
          this.filename = [...files].map(file => file.name).join(', ')
        } else {
          this.filename = null
        }
      } else {
        this.filename = $event.target.value.split('\\').pop()
        // just set the first one
      }
      if (files[0].size < 2048000) {
        this.errors = []
        this.callBack(files[0])
      } else {
        this.errors = ['Taille supérieure à 2M']
      }
    },
  },
}
</script>

<style scoped>
  input[type=file] {
    position: absolute;
    left: -99999px;
  }
</style>
